import Vue from 'vue'

Vue.mixin({
	data() {
		return {
			isPc: true,
			flag: true
		}
	},

    computed: {
        En() {
            return this.i18n.locale === 'en' ? 'En' : ''
        }
    },
	created() {
		this.isPc = document.body.offsetWidth > 768
	},
    methods: {
  	},
})



// WEBPACK FOOTER //
// ./src/mixin/index.js